import Box from "@mui/material/Box"
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react'
import { count } from "../../config/helpers";
import dynamic from "next/dynamic";
import useWindowSize from "../../_hooks/useWindowSize";
import Grid from "@mui/material/Grid";
import useCartDispatch from "@components/_hooks/Cart/useCartDispatch";
import useGlobalSettings from "@components/_hooks/useGlobalSettings";

const ProductHeading = dynamic(() => import('./ProductHeading'))
const ProductCard = dynamic(() => import('./ProductCard/ProductCard'))
const ProductToggle = dynamic(() => import('./ProductTabs/ProductToggle'))
const ProductImage = dynamic(() => import('./ProductImages/ProductImage'))
const ProductCarouselContainer = dynamic(() => import('./ProductCarouselContainer'))
const ProductContainer = (props) => {
    
    const {isMobile} = useWindowSize();
    const { getSetting } = useGlobalSettings()

    const {
        product_extra_media,
        product,
        productData,
        long_term_product,
        price_breaks,
        width,
        depth,
        height,
        measurements,
        product_variants,
        reviews,
        faqs,
        articles,
        videos,
        long_desc,
        key_features,
        addon_groups,
        related_products,
        long_term,
        template_page_settings,
        product_finishes,
        finishes
    } = props;

    const router = useRouter();

    const {RESET_ADDON_PRODUCT} = useCartDispatch();
    const [extra_image_set, set_extra_image_set] = useState(null);
    const [thumbnail_images, set_thumbnail_images] = useState([])
    // console.log(extra_image_set);

    const checkTabs = () => {
        let str = null;
        if(product.product_description_long) {
            str = "description";
        }
        else if(count(Object.keys(measurements)) > 0) {
            str = "measurements";
        }
        else if(count(faqs) > 0) {
            str = "faq";
        }
        else if(count(articles) > 0) {
            str = "related_articles";
        }
        else if(count(videos) > 0) {
            str = "videos";
        }
        else if(count(reviews) > 0) {
            str = "reviews";
        }
    
        return str;
    
      }
    
    
    const [activeTab, setActiveTabValue] = useState(checkTabs);

    const handleChange = (event, newValue) => {
        setActiveTabValue(newValue);
    };

    useEffect(() => {
        RESET_ADDON_PRODUCT();
    }, [router])

    const md_grid = product?.package_core_group_id == null ? 6 : 12

  return (
        <Box className='w-100' >
        <Grid 
            container   
            sx={{
                display: {
                    lg: 'flex',
                }
            }}
            spacing={{
                xs: 0,
                md: 2
            }} 
            className="w-100"
        >
            {product &&  (
                <>
                    <Grid 
                        item xs={12} md={md_grid} lg={6}
                        className='pt-2 pl-0' 
                        itemScope itemType="https://schema.org/Product" 
                        sx={{
                            width: {
                                lg: '100%',
                                xs: '100%'
                            },
                            paddingRight: {
                            } ,
                      
                        }}
                    >
                       { isMobile && 
                        <Box className='pt-0 mb-2 pl-3'>
                            <ProductHeading 
                                product={product}
                                product_rating={product.product_rating}
                                product_rating_count={product.product_rating_count}
                                template_page_settings={template_page_settings}
                            />
                        </Box>
                       }
                        <Box className='position-relative w-100 mb-2 mt-0 ' >
                            <ProductImage
                                product_extra_media={product_extra_media}
                                product={product} 
                                price_breaks={price_breaks}
                                long_term_product={ long_term_product}
                                extra_image_set={extra_image_set}
                                thumbnail_images={thumbnail_images}
                                ecoLeaf={(getSetting('carbon_footprint', 'no') == 'yes') && product?.carbon ? true : false}
                            />
                        </Box>
                    </Grid>
                </>
            )}
      
                {
                    product && (
                        <ProductCard
                            product={product}
                            source={'product'}
                            props={productData}
                            long_term_product={long_term_product}
                            price_breaks={price_breaks}
                            productData={productData}
                            width={width}
                            depth={depth}
                            height={height}
                            product_variants={product_variants}
                            activeTab={activeTab}
                            measurements={measurements}
                            videos={videos}
                            faqs={faqs}
                            long_desc={long_desc}
                            reviews={reviews}
                            articles={articles}
                            key_features={key_features}
                            addon_groups={addon_groups}
                            template_page_settings={template_page_settings}
                            long_term={long_term}
                            related_products={related_products}
                            set_extra_image_set={set_extra_image_set}
                            set_thumbnail_images={set_thumbnail_images}
                            finishes={finishes}
                            product_finishes={product_finishes}
                        />
                    )
                }


           
                {product && (
                    <Grid item xs={12} className='w-100'>
                        {activeTab && activeTab != null && !isMobile && (
                            <ProductToggle
                                product={product}
                                faqs={faqs}
                                articles={articles}
                                videos={videos}
                                reviews={reviews}
                                long_term_product={long_term_product}
                                long_desc={long_desc}
                                width={width}
                                depth={depth}
                                height={height}
                                measurements={measurements}
                                activeTab={activeTab}
                                handleChange={handleChange}
                            />
                        )}
                    </Grid>
                )}
        </Grid>
    </Box>
  )
}

export default ProductContainer